import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';
import { Preferences } from '../../profile/objects/preferences';
import { MCI_COLUMN, NETWORK_DIRECTOR_MODULE } from '../constant/networkDirectorConstant';
import { Column } from '../objects/column';

export const setNetworkDirectorPreference = (
    new_preferences: Preferences[],
    state_columns: Column[],
): ListPreferenceResult => setListPreference(new_preferences, state_columns, {
    module: NETWORK_DIRECTOR_MODULE,
    default_columns: MCI_COLUMN,
    default_order_by: '-created_date',
    default_order: 'asc',
});
